/**
 * wo-number — client mirror of the canonical customer-WO precedence
 * (src/server/services/woNumber.ts, #887). Keep the order identical:
 *
 *   external_ref ?? briefing_wo_number ?? customer_po
 *
 * external_ref is the office-editable slot so it wins; the briefing JSON is
 * the parse-time snapshot; customer_po is a different reference (the PO) and
 * participates only as a last resort — pass { includePo: false } where the PO
 * already renders in its own slot.
 */

export interface WoNumberSource {
    external_ref?: string | null;
    briefing_wo_number?: string | null;
    customer_po?: string | null;
}

const blankToNull = (v: string | null | undefined): string | null => {
    const trimmed = v?.trim();
    return trimmed ? trimmed : null;
};

export function customerWoNumber(row: WoNumberSource, opts: { includePo?: boolean } = {}): string | null {
    const { includePo = true } = opts;
    return (
        blankToNull(row.external_ref) ??
        blankToNull(row.briefing_wo_number) ??
        (includePo ? blankToNull(row.customer_po) : null)
    );
}
